export default __webpack_public_path__ + "static/hero-0dcd201ef3e3b372ca0637b77b68a6c1.jpg";